import React from 'react';
import { MapPin, Phone, Mail, Instagram, Facebook, Heart } from 'lucide-react';
import { businessInfo } from '../mockData';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white pt-16 pb-8">
      <div className="container mx-auto px-6">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* About */}
          <div>
            <h3 className="text-2xl font-bold bg-gradient-to-r from-pink-400 to-rose-400 bg-clip-text text-transparent mb-4">
              Stiletto Nails
            </h3>
            <p className="text-gray-400 mb-4">
              Miami Beach's premier nail destination offering luxury manicures, pedicures, and stunning nail art.
            </p>
            <div className="flex gap-3">
              <a 
                href="#" 
                className="p-2 bg-pink-500/20 hover:bg-pink-500/30 rounded-full transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5 text-pink-400" />
              </a>
              <a 
                href="#" 
                className="p-2 bg-pink-500/20 hover:bg-pink-500/30 rounded-full transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5 text-pink-400" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })} className="text-gray-400 hover:text-pink-400 transition-colors">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('gallery')?.scrollIntoView({ behavior: 'smooth' })} className="text-gray-400 hover:text-pink-400 transition-colors">
                  Gallery
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('booking')?.scrollIntoView({ behavior: 'smooth' })} className="text-gray-400 hover:text-pink-400 transition-colors">
                  Book Appointment
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })} className="text-gray-400 hover:text-pink-400 transition-colors">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-4">Popular Services</h4>
            <ul className="space-y-2 text-gray-400">
              <li>Gel Manicure</li>
              <li>Russian Manicure</li>
              <li>Luxury Volcano Pedicure</li>
              <li>Gel X Extensions</li>
              <li>Custom Nail Art</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-gray-400">
                <MapPin className="w-5 h-5 text-pink-400 flex-shrink-0 mt-0.5" />
                <span className="text-sm">{businessInfo.address}</span>
              </li>
              <li className="flex items-center gap-2 text-gray-400">
                <Phone className="w-5 h-5 text-pink-400" />
                <a href={`tel:${businessInfo.phone}`} className="hover:text-pink-400 transition-colors text-sm">
                  {businessInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-2 text-gray-400">
                <Mail className="w-5 h-5 text-pink-400" />
                <a href={`mailto:${businessInfo.email}`} className="hover:text-pink-400 transition-colors text-sm">
                  {businessInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} Stiletto Nails on the Beach. All rights reserved.
            </p>
            <div className="flex items-center gap-2 text-sm text-gray-400">
              <span>Women-Owned</span>
              <span>•</span>
              <span>Latino-Owned</span>
              <span>•</span>
              <span className="flex items-center gap-1">
                Made with <Heart className="w-4 h-4 fill-pink-500 text-pink-500" /> in Miami Beach
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
